/**
 * Data register user mock
 */

import { IParamGetList } from 'models/UserRequest';
import { ParamsGetListSetting } from 'utils/constants';
import { RowHeader } from 'utils/types';

export const headerRegisterUser: RowHeader[] = [
  { id: 'no', label: 'No', position: 'center', haveSort: false },
  { id: 'icon', label: '利用状況', haveSort: false },
  { id: 'edit', label: '', haveSort: false },
  { id: 'company_name', label: '企業名/団体名' },
  { id: 'department', label: '所属' },
  { id: 'username', label: '名前' },
  { id: 'email', label: 'メールアドレス' },
  { id: 'address', label: '住所' },
  { id: 'company_phone_number', label: '会社電話番号' },
  { id: 'phone_number', label: '携帯電話番号' },
  { id: 'created_at', label: '登録日' },
  { id: 'delete_item', label: '登録情報削除', position: 'center', haveSort: false },
];

export const defaultParamsGetRegisterUser: IParamGetList = {
  keyword: '',
  order_by: 'desc',
  sort_name: 'created_at',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
};
